export interface IHospitalPrescriptionPublicModel {
  hospitalPrescriptionId: number;
  fullName: string | undefined;
  optionDisplayName: string | undefined;
  // Additional properties can be added as needed
}

export class HospitalPrescriptionPublicModel
  implements Record<keyof IHospitalPrescriptionPublicModel, any>
{
  hospitalPrescriptionId: number;
  fullName: string | undefined;
  optionDisplayName: string | undefined;

  constructor(params?: Partial<IHospitalPrescriptionPublicModel>) {
    this.hospitalPrescriptionId = _.defaultTo(
      params?.hospitalPrescriptionId,
      0,
    );
    this.fullName = params?.fullName;
    this.optionDisplayName = params?.optionDisplayName;
  }
}
